import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowRight }from 'lucide-react'
import { FaGithub }from 'react-icons/fa'
import logo_no_bg from './../media/img/evalys_logo.png'
import { ReactComponent as EvalysLogo } from './../media/img/evalys_logo_svg.svg';
import cancel_icon from './../media/icons/close.png'
import nav_icon from './../media/icons/menu.png'
import { images } from '../utilities/img';
import { setgtMessage } from '../redux/gtmsgSlice';
import { useDispatch } from 'react-redux';
import { gtNeutral } from '../redux/gtstatusSlice';


const NavBar = () => {
    
    const pathlocation = useLocation()
    
    const windowscrollvalue = window.scrollY
    const [showmobilenav, setshowmobilenav] = useState(null)
    const [windowWidth, setWindowWidth] = useState(window.innerWidth)

    const dispatch = useDispatch()

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
            console.log(window.innerWidth)
        };

        const handleScroll = () => {
            // console.log(window.scrollY)
            setshowmobilenav(null)
        }

        window.addEventListener('resize', handleResize);

        window.addEventListener('scroll', handleScroll);

        // Cleanup: Remove the event listener when the component is unmounted
        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('scroll', handleScroll)
        };
    }, []);

    const handleMobilenav = () => {
        if(!showmobilenav) {
            setshowmobilenav(true)
        } else {
            setshowmobilenav(false)
        }
    }

    const handleComingSoon = () => {
        dispatch(setgtMessage('COMING SOON'))
        dispatch(gtNeutral())
    }



    return ( 
        <>
            {pathlocation.pathname !== '/eva' && pathlocation.pathname !== '/shop' ? 
                <>
                    <header data-aos="fade-down" data-aos-duration="2000">
                        <div className="header-inner">
                            <a href="" className='flex gap-10 align-center logo'>
                                <img src={images.general.eva_logo_green} alt="" />
                                {/* <EvalysLogo className='logo-svg' /> */}
                                <p className="lg_bold ">Evalys</p>
                            </a>

                            {/* {windowWidth > 991 ? */}
                                <ul className='flex row align-center'>
                                    {/* <li className='nav-link'><a href='https://evalys.gitbook.io/evalys'>Whitepaper</a></li> */}
                                    {/* <li className='nav-link'><a href='#' target='_blank'>Github</a></li> */}
                                    {/* <li className='nav-link'><Link to='shop'>Shop</Link></li> */}
                                    {/* <li className='nav-link'><a href='#tokenomics'>Tokenomics</a></li> */}
                                    {/* <li className='join-btn'><Link to='#'>Join Now</Link></li> */}
                                    <li>
                                        <div className="hd-icon position-relative">
                                            <div className="hd-icon-effect top-right"></div>
                                            <div className="hd-icon-effect bottom-left"></div>
                                            <a href='https://x.com/evalysfun/' target='_blank' className='header-icon-box flex justify-center align-center'>
                                                <img src={images.general.x_icon} alt="" />
                                            </a>
                                        </div>
                                    </li>
                                    {windowWidth < 600 ? <li>
                                        <div className="hd-icon position-relative">
                                            <div className="hd-icon-effect top-right"></div>
                                            <div className="hd-icon-effect bottom-left"></div>
                                            <a href='https://github.com/evalysfun' target='_blank' className='header-icon-box flex justify-center align-center'>
                                                {/* <img src={images.general.x_icon} alt="" /> */}
                                                <FaGithub size={20} color='rgba(255, 255, 255, 1)' />
                                            </a>
                                        </div>
                                    </li> : null}
                                    {windowWidth > 600 ? <li>
                                        <div className="ngs-btn-box position-relative">
                                            <div className="ng-effect top-right"></div>
                                            <div className="ng-effect bottom-left"></div>
                                            <a href='https://github.com/evalysfun' target='_blank' className='ngs-btn lg_regular'>Github</a>
                                        </div>
                                    </li> : null}
                                    <li>
                                        <div className="ngs-btn-box position-relative">
                                            <div className="ng-effect top-right"></div>
                                            <div className="ng-effect bottom-left"></div>
                                            <div className='ngs-btn lg_regular flex row align-center gap-10 cursor-pointer'>
                                                V.1.0
                                                {/* <ArrowRight size={15} color='rgba(255, 255, 255, 1)' /> */}
                                            </div>
                                        </div>
                                    </li>
                                    {/* <li>
                                        <Link to='https://x.com/evalyshome' target='_blank' className='gs-btn'>
                                            About us
                                        </Link>
                                    </li> */}
                                </ul>
                            {/* : null} */}
                        </div>

                        {/* {windowWidth < 991 ? 
                            <div className='nav-icon' onClick={handleMobilenav}>
                                <img src={showmobilenav ? cancel_icon : nav_icon} alt="" />
                            </div>
                        : null} */}
                    </header>

                    <div className={`mobile-nav ${showmobilenav ? 'active' : ''}`}>
                        <div className="mobile-nav-item">
                            <a href='https://evalys.gitbook.io/evalys' className='open-sans_f' target='_blank'>Whitepaper</a>
                        </div>
                        <div className="mobile-nav-item">
                            <a href='#' target='_blank' className='open-sans_f'>Github</a>
                        </div>
                        <div className="mobile-nav-item">
                            <Link to='shop' className='open-sans_f'>Shop</Link>
                        </div>
                        {/* <div className="mobile-nav-item">
                            <a href='#tk' className='open-sans_f'>Tokenomics</a>
                        </div> */}
                        <div className="mobile-nav-item">
                            <Link to='' target='_blank' className='open-sans_f'>
                                About us
                            </Link>
                        </div>
                    </div>
                </>
            
            : null}

        </>
    );
}
 
export default NavBar;